import { palette } from './palette';

export const homeStyle = {
  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      '& .hero-shaped__left-side': {
        flex: '0 0 60%',
        maxWidth: '60%',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },

        '& .hero-shaped__image': {
          width: '60vw',

          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          },
        },
      },
    },
  },

  '.header-wrapper': {
    background: `${palette.text.highlight} !important`,
    padding: '8px 16px',
    '& .MuiToolbar-root': {
      minHeight: '72px',
    },
  },

  '.group-parent-container': {
    '& .home-static-hero-wrapper': {
      '& .MuiButton-containedPrimary': {
        backgroundColor: `${palette.primary.main} !important`,
        color: `${palette.text.highlight} !important`,
        '&:hover': {
          backgroundColor: `${palette.primary.main} !important`,
          color: `${palette.text.highlight} !important`,
          opacity: 0.92,
        },
      },
    },
    '& .normal-text': {
      fontWeight: 500,
      fontFamily: 'InterDisplay-Medium !important',
      fontSize: '64px !important',
      lineHeight: '72px !important',
      letterSpacing: '-0.64px !important',
      '@media (min-width: 600px) and (max-width: 1024px)': {
        fontSize: '52px !important',
        lineHeight: '64px !important',
        letterSpacing: '-1.04px !important',
      },
      '@media (max-width: 600px)': {
        fontSize: '44px !important',
        lineHeight: '48px !important',
        letterSpacing: '-0.88px !important',
      },
    },
    '& .hero-home-button': {
      color: palette.text.highlight,
      borderColor: palette.text.highlight,

      '&:hover': {
        borderColor: palette.text.highlight,
      },
    },

    '& .savings-hero-section, .checkout-hero-section, .plan-selection-section,.faq-hero-section, .dashboard-hero-section, .find-provider-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section':
    {
      marginTop: 88,
      '& .hero-home-button': {
        background: `${palette.secondary.light} !important`,
      },
      background: `${palette.primary.main} !important`,

      backgroundSize: 'cover',
      '& .hero-header-title': {
        fontFamily: 'InterDisplay-Medium !important',
        fontSize: '40px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.8px !important',
        fontWeight: 500,
      },

      '& h1,& h2,& h3,& h4,& p': {
        color: palette.text.highlight,
      },
    },

    '& .subscription-wrapper, .addonsWrapper, .plan-selection-container': {
      '& .MuiSwitch-thumb': {
        background: palette.primary.main,
      },
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.text.highlight,
      },
      '& .MuiSwitch-track': {
        border: 'none',
        background: palette.text.highlight,
      },
    },

    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0,
    },

    /* Hero Section - Styles */
    '& .home-hero-variant-2': {
      marginTop: '80px',
    },
    '& .home-hero-wrapper': {
      backgroundColor: palette.background.primary,

      '@media(max-width: 600px)': {
        paddingTop: '40px !important',
      },
      '& .hero-background': {
        objectFit: 'cover',
        backgroundColor: palette.background.primary,
        '@media screen and (max-width: 600px)': {
          height: '440px',
        },
        '@media(max-width: 1200px) and (min-width: 600px)': {
          objectFit: 'cover',
        },
        '@media screen and (min-width: 1800px)': {
          objectFit: 'contain',
        },
      },
      '& .hero-section': {
        display: 'flex',
        alignItems: 'center',
        maxHeight: '700px',
        '& .section-alternate__content': {
          backgroundColor: palette.background.primary,
          '@media(max-width: 1200px)': {
            width: '100% !important',
            padding: '0px 50px !important',
            paddingRight: '0px !important',
            '@media(max-width: 600px)': {
              padding: '0px 40px !important',
            },
          },
        },
        '& .section-header': {
          '@media screen and (min-width: 768px)': {
            marginTop: '60px',
          },
          '& .section-header__cta-container': {
            '@media(max-width: 600px)': {
              justifyContent: 'center !important',
            },
          },
        },
      },
      '& .home-hero-title': {
        fontSize: '64px !important',
        fontFamily: 'InterDisplay-Medium',
        fontWeight: 500,
        maxWidth: 634,
        lineHeight: '72px !important',
        letterSpacing: '-1.28px',
        '@media(max-width: 1024px) and (min-width: 600px)': {
          fontSize: '48px !important',
          lineHeight: '56px !important',
          letterSpacing: '-1.04px !important',
        },
        '@media(max-width: 600px)': {
          lineHeight: '44px !important',
          letterSpacing: '-0.72px !important',
          textAlign: 'center !important',
        },
      },
      '& .home-hero-subtitle': {
        maxWidth: 550,
        fontFamily: 'InterDisplay-Regular',
        fontWeight: 400,
        lineHeight: '28px !important',
        letterSpacing: '-0.48px !important',
        color: `${palette.text.tertiaryLight} !important`,
        '@media(max-width: 600px)': {
          textAlign: 'center !important',
        },
      },
      '@media screen and (max-width: 900px)': {
        '& .home-hero-title': {
          fontSize: '2.5rem !important',
        },
        '& .home-hero-subtitle': {
          fontSize: 16,
          fontFamily: 'InterDisplay-Regular',
          maxWidth: 550,
        },
      },
    },

    '& .home-hero-variant-1.home-hero-wrapper': {
      '&.image-align-bottom': {
        paddingBottom: '0 !important',
      },
      /* Mobile / tablet: Figma hero — warm canvas, white card, centered copy, pill CTAs, waved image */
      '@media (max-width: 1024px)': {
        '&.image-align-bottom': {
          marginTop: '100px !important',
        },
        background: `${palette.background.heroCanvas} !important`,
        paddingTop: '16px !important',
        paddingBottom: '0 !important',
        paddingLeft: 'clamp(12px, 4vw, 20px) !important',
        paddingRight: 'clamp(12px, 4vw, 20px) !important',
        maxHeight: 'none !important',
        '&.image-align-bottom .hero-section': {
          height: 'auto !important',
          overflow: 'hidden !important',
        },
        '& .hero-section': {
          display: 'block !important',
          maxHeight: 'none !important',
          padding: '0 !important',
          overflow: 'visible !important',
        },
        '& .hero-section.section-alternate': {
          marginTop: 0,
          marginLeft: 'auto',
          marginRight: 'auto',
          maxWidth: '100% !important',
          width: '100%',
          paddingInline: '0 !important',
        },
        '& .hero-section .section-alternate__content': {
          backgroundColor: `${palette.background.paper} !important`,
          borderRadius: '28px',
          boxShadow: '0 14px 40px rgba(30, 35, 29, 0.08)',
          padding: '0 !important',
          overflow: 'hidden',
          maxWidth: '100% !important',
          width: '100%',
        },
        '& .hero-section-grid.MuiGrid-container': {
          flexDirection: 'column',
          flexWrap: 'nowrap',
          margin: '0 !important',
          width: '100% !important',
        },
        '& .hero-section-grid > .MuiGrid-item': {
          padding: '0 !important',
          maxWidth: '100% !important',
        },
        '& .hero-left-section': {
          padding: '40px 24px 28px !important',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
        },
        '& .section-header.MuiGrid-container': {
          marginBottom: '0 !important',
          width: '100%',
          maxWidth: '520px',
          marginLeft: 'auto',
          marginRight: 'auto',
          padding: '20px !important',
          '& .section-header__title-wrapper, & .section-header__subtitle-wrapper': {
            width: '100%',
          },
          '& .section-header__cta-wrapper.MuiGrid-item': {
            flexBasis: '100% !important',
            maxWidth: '100% !important',
          },
          '& .section-header__cta-container': {
            justifyContent: 'center !important',
            flexWrap: 'nowrap !important',
            gap: '16px',
            width: '100%',
            maxWidth: '100%',
            '@media (max-width: 600px)': {
              gap: '20px',
            },
          },
          '& .section-header__cta-item-wrapper': {
            marginLeft: '0 !important',
            flex: '1 1 0',
            minWidth: 0,
            display: 'flex',
            justifyContent: 'center',
          },
        },
        '& .home-hero-title, & .hero-title, & .section-header__title': {
          color: `${palette.text.tertiary} !important`,
          fontFamily: 'InterDisplay-Medium, InterDisplay-Regular, sans-serif !important',
          fontSize: '28px !important',
          lineHeight: '34px !important',
          letterSpacing: '-0.56px !important',
          fontWeight: 500,
          textAlign: 'center !important',
          maxWidth: '100% !important',
        },
        '& .home-hero-subtitle, & .hero-subtitle, & .section-header__subtitle': {
          color: `${palette.text.secondary} !important`,
          fontFamily: 'InterDisplay-Regular, sans-serif !important',
          fontSize: '16px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.32px !important',
          fontWeight: 400,
          textAlign: 'center !important',
          maxWidth: '100% !important',
          marginTop: '12px',
        },
        '& .primary-button.MuiButton-root': {
          width: 'calc(100% - 15px) !important',
          maxWidth: 'none !important',
          marginTop: '0 !important',
          marginRight: '15px !important',
          padding: '12px 12px !important',
          borderRadius: '999px !important',
          fontSize: '15px !important',
          lineHeight: '20px !important',
          letterSpacing: '-0.2px !important',
          textTransform: 'none !important',
          fontWeight: 500,
          backgroundColor: '#707566 !important',
          color: `${palette.text.highlight} !important`,
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: '#5f6559 !important',
            color: `${palette.text.highlight} !important`,
          },
        },
        '& .secondary-button.MuiButton-root': {
          width: '100% !important',
          maxWidth: 'none !important',
          marginTop: '0 !important',
          marginLeft: '0 !important',
          padding: '12px 12px !important',
          borderRadius: '999px !important',
          fontSize: '15px !important',
          lineHeight: '20px !important',
          letterSpacing: '-0.2px !important',
          textTransform: 'none !important',
          fontWeight: 500,
          backgroundColor: `${palette.background.paper} !important`,
          border: '1px solid #707566 !important',
          color: `${palette.text.secondary} !important`,
          '&:hover': {
            backgroundColor: `${palette.background.primaryLight} !important`,
            border: '1px solid #707566 !important',
          },
        },
        '& .image-wrapper': {
          position: 'relative',
          width: '100%',
          minWidth: 0,
          margin: 0,
          padding: 0,
          minHeight: 'min(52vw, 280px)',
          display: 'block',
          clipPath:
            'path("M 0 30% C 32% 10% 68% 4% 100% 14% L 100% 100% L 0 100% Z")',
          WebkitClipPath:
            'path("M 0 30% C 32% 10% 68% 4% 100% 14% L 100% 100% L 0 100% Z")',
          '& .lazy-load-image-background': {
            width: '100% !important',
            height: '100% !important',
            minHeight: 'min(52vw, 280px) !important',
            display: 'block !important',
            position: 'relative',
          },
          '& .lazy-load-image-background > span': {
            display: 'block !important',
            width: '100% !important',
            height: '100% !important',
            minHeight: 'min(52vw, 280px) !important',
          },
          '& .image, & img': {
            width: '100% !important',
            height: '100% !important',
            minHeight: 'min(52vw, 280px) !important',
            maxWidth: 'none !important',
            objectFit: 'cover',
            objectPosition: 'center center',
            display: 'block',
          },
        },
      },
      '@media (min-width: 1024px)': {
        background: `${palette.background.heroCanvas} !important`,
        paddingTop: '40px !important',
        paddingBottom: '48px !important',
        paddingLeft: 'clamp(12px, 2.5vw, 40px)',
        paddingRight: 'clamp(12px, 2.5vw, 40px)',
        maxHeight: 'none !important',
        '& .hero-section': {
          /* Block layout: flex + stretch was sizing the card taller than the grid row (empty white under content). */
          display: 'block !important',
          maxHeight: 'none !important',
          overflow: 'visible !important',
          /* HeroVariant1 makeStyles heroSection adds padding bottom ≥md — leaves white under the image */
          padding: '0 !important',
        },
        '& .hero-section.section-alternate': {
          maxWidth: 'min(1240px, calc(100vw - 24px)) !important',
          marginTop: '100px',
          marginLeft: 'auto',
          marginRight: 'auto',
          marginBottom: 0,
          width: '100%',
          paddingInline: '0 !important',
          overflow: 'visible !important',
        },
        '& .hero-section .section-alternate__content': {
          backgroundColor: `${palette.background.paper} !important`,
          borderRadius: '28px',
          boxShadow: '0 18px 48px rgba(30, 35, 29, 0.09)',
          padding: '0 !important',
          overflow: 'hidden',
          maxWidth: '100% !important',
          width: '100%',
          height: 'fit-content',
          minHeight: 0,
        },
        '& .hero-section-grid.MuiGrid-container': {
          alignItems: 'stretch !important',
          margin: 0,
          width: '100%',
          flexWrap: 'nowrap',
          '& > .MuiGrid-item': {
            minWidth: 0,
            paddingBottom: '0 !important',
            display: 'flex',
            flexDirection: 'column',
            alignSelf: 'stretch',
          },
        },
        '& .hero-left-section': {
          padding: '40px 28px 40px 44px !important',
          display: 'flex',
          alignItems: 'center',
          minWidth: 0,
        },
        '& .section-header': {
          marginTop: '0 !important',
        },
        '& .home-hero-title, & .hero-title': {
          color: `${palette.text.tertiary} !important`,
          maxWidth: '100%',
        },
        '& .home-hero-subtitle, & .hero-subtitle': {
          color: `${palette.text.secondary} !important`,
          maxWidth: '100%',
        },
        /*
          Absolute-only children do not grow the grid cell, so the image column stayed short.
          Flex column + flex:1 on the lazy wrapper and img fills the row height from the text column.
        */
        '& .image-wrapper': {
          padding: '0 !important',
          margin: '0 !important',
          overflow: 'hidden',
          position: 'relative',
          width: '100%',
          minWidth: 0,
          flex: '1 1 auto',
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
          clipPath:
            'path("M 11% 0 C 0% 24%, 0% 76%, 11% 100% L 100% 100% L 100% 0 Z")',
          '& .lazy-load-image-background': {
            position: 'relative',
            flex: '1 1 auto',
            minHeight: 0,
            width: '100% !important',
            maxWidth: 'none !important',
            display: 'flex !important',
            flexDirection: 'column',
          },
          '& .lazy-load-image-background > span': {
            flex: '1 1 auto',
            minHeight: 0,
            display: 'flex !important',
            flexDirection: 'column',
            width: '100% !important',
            maxWidth: 'none !important',
          },
          '& .image, & img': {
            flex: '1 1 auto',
            minHeight: 0,
            width: '100% !important',
            maxWidth: 'none !important',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'center center',
            display: 'block',
          },
          '& .lazy-load-image-background img': {
            flex: '1 1 auto',
            minHeight: 0,
            width: '100% !important',
            maxWidth: 'none !important',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'center center',
            display: 'block',
          },
        },
        '& .secondary-button.MuiButton-outlinedPrimary': {
          backgroundColor: `${palette.background.paper} !important`,
          border: `1px solid ${palette.background.border} !important`,
          color: `${palette.text.secondary} !important`,
          '&:hover': {
            backgroundColor: `${palette.background.primaryLight} !important`,
          },
        },
      },
      '@media (min-width: 1200px)': {
        paddingTop: '48px !important',
        paddingBottom: '56px !important',
        paddingLeft: 'clamp(16px, 3vw, 40px)',
        paddingRight: 'clamp(16px, 3vw, 40px)',
        '& .hero-left-section': {
          padding: '44px 40px 44px 56px !important',
        },
        '& .home-hero-title, & .hero-title': {
          maxWidth: 580,
        },
        '& .home-hero-subtitle, & .hero-subtitle': {
          maxWidth: 520,
        },
      },
    },

    /* Benefits - Styles */
    '& .definition-Wrapper': {
      backgroundColor: palette.background.primaryLight,
      '& .definition-variant-2': {
        paddingInline: '56px !important',
        '@media(max-width: 600px)': {
          paddingInline: '10px !important',
          paddingTop: '10px !important',
        },
        '@media(min-width: 600px) and (max-width: 900px)': {
          padding: '20px !important',
        },
      },
      '@media(max-width: 1200px) and (min-width: 600px)': {
        padding: ' 0px 20px !important',
      },
      '& .benefits-wrapper': {
        '& .customImageWrapper': {
          display: 'flex !important',
          justifyContent: 'center',
          alignItems: 'stretch',
          width: '100% !important',
          overflow: 'hidden',
          position: 'relative',
          '@media(max-width: 600px)': {
            height: '382px !important',
            minHeight: '382px !important',
          },
          '@media(min-width: 600px) and (max-width: 1200px)': {
            height: '400px !important',
            minHeight: '400px !important',
          },
          '@media(min-width: 1200px)': {
            height: '800px !important',
            minHeight: '800px !important',
          },
          '& .lazy-load-image-background': {
            width: '100% !important',
            height: '100% !important',
            minHeight: '100% !important',
            display: 'block !important',
            position: 'relative',
            borderRadius: '12px',
            overflow: 'hidden',
            '& img, & .image': {
              width: '100% !important',
              height: '100% !important',
              minHeight: '100% !important',
              objectFit: 'cover !important',
              display: 'block !important',
              position: 'absolute',
              top: 0,
              left: 0,
              borderRadius: '24px',
            },
          },
          '& img, & .image': {
            width: '100% !important',
            height: '100% !important',
            minHeight: '100% !important',
            objectFit: 'cover !important',
            display: 'block !important',
            borderRadius: '24px',
          },
        },
      },
      '& .section-alternate__content': {
        padding: '48px 16px',

        '@media (min-width: 600px)': {
          padding: '48px 16px',
        },
        '@media (min-width: 900px) and (max-width: 1200px)': {
          padding: '0px 0px 0px',
        },
        '@media (min-width: 1200px)': {
          padding: '0px 48px 0px',
        },

      },
      '& .definition-service-tile': {
        borderBottom: `0.5px solid ${palette.background.border} !important`,
        '& .definition-service-innertile': {
          justifyContent: 'left !important',
        },
      },
      '& .definition-services-grid': {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: 24,
        justifyContent: 'center',
        alignItems: 'stretch',

        '@media screen and (max-width: 900px)': {
          gridTemplateColumns: '1fr',
        },
      },
      '& .definition-services-grid': {
        paddingTop: '16px !important',
      },
      '& .MuiCardContent-root': {
        padding: 32,
      },
      '& .definition-service-header': {
        justifyContent: 'flex-end',
        flexDirection: 'row-reverse',
        marginBottom: 24,
      },
      '& .definition-service-title': {
        fontWeight: 500,
        fontFamily: 'InterDisplay-Regular !important',
        fontSize: '28px !important',
        lineHeight: '28px !important',
        letterSpacing: '-0.28px !important',
        textAlign: 'left !important',
        paddingBottom: '10px !important',
        '@media(max-width: 600px)': {
          fontSize: '24px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.48px !important',
        },
      },

      '& .customIcon': {
        justifyContent: 'left !important',
        paddingBottom: '30px !important',
      },
      '& .definition-service-description': {
        marginBottom: 0,
        fontSize: '16px !important',
        lineHeight: '22px !important',
        color: palette.text.tertiaryLight,
        textAlign: 'left !important',
        letterSpacing: '-0.32px !important',
      },
      '& .section-header__title': {
        fontWeight: 500,
        whiteSpace: 'pre-line',
        fontFamily: 'InterDisplay-Medium !important',
        fontSize: '48px !important',
        lineHeight: '56px !important',
        letterSpacing: '-1.68px !important',
        paddingBottom: '24px !important',
        '@media(min-width: 600px) and (max-width: 1200px)': {
          fontSize: '48px !important',
          lineHeight: '48px !important',
          letterSpacing: '-0.96px !important',
        },
        '@media(max-width: 600px)': {
          fontSize: '44px !important',
          lineHeight: '44px !important',
          letterSpacing: '-0.88px !important',
        },
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      padding: '0px 16px !important',
      '& .section-alternate__content': {
        '@media (min-width: 1200px)': {
          paddingTop: '0 !important',
        },
      },
      '& .subscription-bg': {
        height: '100%',
        background: palette.background.primary,
        backgroundRepeat: 'no-repeat, no-repeat',
      },
      '& .section-header__title, .summary-text, .summary-subtext, .subscription-tabs-label':{
        color: `${palette.text.primary} !important`,
      },
      '& .section-header__title': {
        fontWeight: 500,
        fontFamily: 'InterDisplay-Medium !important',
        fontSize: '48px !important',
        lineHeight: '72px !important',
        letterSpacing: '-1.68px !important',
        whiteSpace: 'pre-line',
        '@media screen and (max-width: 900px) and (min-width: 600px)': {
          fontSize: '44px !important',
          lineHeight: '44px !important',
          letterSpacing: '-0.88px !important',
        },
        '@media(max-width: 600px)': {
          fontSize: '40px !important',
          lineHeight: '40px !important',
          letterSpacing: '-0.72px !important',
        },
      },
      '& .section-header__subtitle': {
        fontWeight: 400,
        fontFamily: 'InterDisplay-Regular !important',
        fontSize: '18px !important',
        lineHeight: '28px !important',
        letterSpacing: '-0.48px !important',
        color: `${palette.text.tertiaryLight} !important`,
        '@media screen and (max-width: 700px)': {
          fontSize: '18px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.4px !important',
        },
      },
      '& .summary-text': {
        fontWeight: 400,
      },
      '& #pricing-benefit-section': {
        '& .planCard': {
          fontWeight: 400,
          fontSize: '16px !important',
          lineHeight: '20px !important',
          letterSpacing: '-0.32px !important',
          borderRadius: '4px !important',
          border: 'none !important',
          '&:hover': {
            color: palette.text.primary,
            background: palette.text.highlight,
            '& hr': {
              color: palette.text.secondary,
            },
          },
          '& .MuiButton-containedPrimary': {
            backgroundColor: palette.primary.light,
            color: palette.text.tertiary,
            '&:hover': {
              backgroundColor: palette.primary.main,
              color: palette.text.highlight,
              transition: 'none !important',
            },
          },
          '& .customcardTitle': {
            fontWeight: 500,
            fontFamily: 'InterDisplay-Medium !important',
            fontSize: '32px !important',
            lineHeight: '28px !important',
            letterSpacing: '-0.64px !important',
            color: palette.text.tertiary,
          },
          '& .price-value': {
            fontWeight: 500,
            fontSize: '32px !important',
            fontFamily: 'InterDisplay-Medium !important',
            lineHeight: '40px !important',
            letterSpacing: '-0.8px !important',
            color: palette.text.primary,
            '@media screen and (max-width: 700px)': {
              fontSize: '32px !important',
              lineHeight: '32px !important',
              letterSpacing: '-0.64px !important',
            },
          },
          '& .customUpfrontWrapper': {
            color: palette.text.tertiaryLight,
            fontWeight: 400,
            lineHeight: '16px !important',
            letterSpacing: '-0.42px !important',
            fontStyle: 'italic',
          },
        },
        '& .subscription-section': {
          objectFit: 'cover',
          '& .section-header': {
            maxWidth: 720,

            '@media(min-width: 900px)': {
              margin: '0px auto 32px',
            },
            '@media(max-width: 900px)': {
              margin: '0px auto 32px',
            },
          },
          '& .plans-loader': {
            color: palette.text.secondary,
          },
        },
        '& .bold': {
          fontWeight: 500,
          fontSize: '20px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.48px !important',
          color: `${palette.text.secondary} !important`,
          fontFamily: 'InterDisplay-Medium !important',
          '@media screen and (max-width: 700px)': {
            fontSize: '18px !important',
            lineHeight: '22px !important',
          },
        },
        '& .summary-text': {
          fontWeight: 500,
          fontSize: '18px !important',
          lineHeight: '28px !important',
          letterSpacing: '-0.48px !important',
          fontFamily: 'InterDisplay-Regular !important',
          color: `${palette.text.primary} !important`,
        },
        '& .summary-subtext': {
          fontWeight: 500,
          fontSize: '18px !important',
          lineHeight: '28px !important',
          letterSpacing: '-0.48px !important',
          color: `${palette.text.primary} !important`,
        },
        '& .savings-summary-link': {
          color: `${palette.primary.main} !important`,
          textDecoration: 'underline',
          cursor: 'pointer',
        },
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: palette.background.default,
      '& .section': {
        '@media(min-width: 600px) and (max-width: 1024px)': {
          padding: '40px !important',
        },
        '@media(min-width: 1024px)': {
          padding: '40px 80px !important',
        },
        '@media(max-width: 600px)': {
          padding: '24px 20px !important',
        },
      },

      '& .cover-image-wrapper': {
        display: 'flex !important',
        justifyContent: 'center',
        alignItems: 'stretch',
        width: '100% !important',
        overflow: 'hidden',
        position: 'relative',
        '@media(min-width: 600px) and (max-width: 1024px)': {
          height: '500px !important',
          minHeight: '500px !important',
        },
        '@media(min-width: 1024px)': {
          height: '560px !important',
          minHeight: '560px !important',
        },
        '@media(max-width: 600px)': {
          height: '382px !important',
          minHeight: '382px !important',
        },
        '& img, & .image, & .how-cover-image': {
          width: '100% !important',
          height: '100% !important',
          minHeight: '100% !important',
          objectFit: 'cover !important',
          display: 'block !important',
          position: 'absolute',
          top: 0,
          left: 0,
        },
      },
      '& .howitworks-title': {
        '& .section-header__title': {
          whiteSpace: 'pre-line',
          fontFamily: 'InterDisplay-Medium !important',
          fontSize: '52px !important',
          lineHeight: '56px !important',
          letterSpacing: '-1.04px !important',
          fontWeight: 500,
          '@media(min-width: 600px) and (max-width: 1200px)': {
            fontSize: '48px !important',
            lineHeight: '48px !important',
            letterSpacing: '-0.96px !important',
          },
          '@media(max-width: 600px)': {
            fontSize: '44px !important',
            lineHeight: '44px !important',
            letterSpacing: '-0.88px !important',
          },
        },
        '& .section-header__subtitle': {
          fontWeight: 400,
          fontSize: '20px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.8px !important',
          '@media(max-width: 1200px)': {
            fontSize: '18px !important',
            lineHeight: '22px !important',
            letterSpacing: '-0.8px !important',
          },
        },
        marginBottom: 40,
      },

      '& .howitworks-wrapper': {
        padding: 20,
      },

      '& .howitworks-wrapper-left': {
        padding: 20,
        paddingLeft: '0 !important',
        '@media(max-width: 1000px)': {
          paddingTop: '40px !important',
        },
      },

      '& .makeStyles-root-54': {
        padding: 0,
      },

      '& .step-counter': {
        borderRadius: '50%',
        backgroundColor: palette.background.tableHead,
        color: palette.text.highlight,
        fontSize: 15,
      },

      '& .working-steps-container': {
        maxWidth: '560px',
        '& .step-title': {
          fontSize: 24,
          lineHeight: '24px !important',
          letterSpacing: '-0.4px !important',
          fontWeight: 400,
          fontFamily: 'InterDisplay-Regular !important',
          paddingBottom: '8px !important',
          '@media(max-width: 600px)': {
            fontSize: '22px !important',
            lineHeight: '24px !important',
            letterSpacing: '-0.44px !important',
          },
        },
        '& .step-content': {
          fontSize: 18,
          color: palette.text.tertiaryLight,
          lineHeight: '22px !important',
          letterSpacing: '-0.36px !important',
          fontWeight: 400,
          '@media(max-width: 1200px)': {
            fontSize: '16px !important',
            lineHeight: '22px !important',
            letterSpacing: '-0.32px !important',
          },
        },
      },

      '& .step-started-button': {
        '& .right-icon': {
          color: palette.text.highlight,
        },
      },

      '& .working-steps-container:not(:last-child)': {
        paddingBottom: 30,
      },

      '@media screen and (max-width: 900px)': {
        '& .howitworks-wrapper-left': {
          padding: '5px',
        },
      },

      '@media(min-width: 900px)': {
        '& .howitworks-wrapper-left': {
          paddingLeft: '40px',
        },
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .savings-hero-section': {
        background: `${palette.background.dark}`,
        backgroundSize: 'cover',
        '& .hero-home-button': {
          background: 'transparent !important',
        },
      },
      '& .section-header': {
        '& .hero-header-title': {
          fontFamily: 'InterDisplay-Medium !important',
          fontSize: '40px !important',
          lineHeight: '40px !important',
          letterSpacing: '-0.8px !important',
          fontWeight: 500,
        },
        '& .hero-header-subtitle': {
          fontFamily: 'InterDisplay-Regular !important',
          fontSize: '18px !important',
          lineHeight: '20px !important',
          letterSpacing: '-0.4px !important',
          fontWeight: 400,
        },
      },
      '& .select-location-grid': {
        width: '100%',
        maxWidth: 'unset',
        flexBasis: 'auto',
      },
      '& .service-procedure-table': {
        border: `1px solid ${palette.primary.main} !important`,
        '& .savings-topheader': {
          color: `${palette.text.highlight} !important`,
        },

        '& .savings-header': {
          color: palette.text.primary,
        },

        '& .savings-subheader': {
          backgroundColor: palette.background.main,
          color: palette.text.primary,
          fontWeight: 600,
        },
      },

      '& .savings-contact-card': {
        padding: '0px 0px 0px 0px !important',
        backgroundColor: palette.surface.light,
      },

      '& .footer-bar': {
        backgroundColor: `${palette.background.offer} !important`,
      },

      '& .footer-bar-text': {
        color: `${palette.text.highlight} !important`,
      },
      '& .MuiButton-containedSecondary': {
        backgroundColor: palette.primary.main,
        color: palette.text.highlight,
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      '& .section-alternate': {
        '& .section-alternate__content': {
          paddingInline: '0 !important',
          '@media(max-width: 600px)': {
            paddingInline: '40px !important',
          },
        },
        '@media(min-width: 900px)': {
          height: 200,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          paddingInline: '90px !important',
        },
      },
      '& .hero-static-bg': {
        backgroundColor: `${palette.background.hero1} !important`,
      },
      '& .section-header__title': {
        color: `${palette.text.primary} !important`,
        fontWeight: 500,
        fontFamily: 'InterDisplay-Medium !important',
        fontSize: '40px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.8px !important',
        '@media screen and (max-width: 700px)': {
          fontSize: '30px !important',
          lineHeight: '30px !important',
          letterSpacing: '-0.6px !important',
        },
        '@media(min-width: 600px) and (max-width: 1200px)': {
          fontSize: '36px !important',
          lineHeight: '40px !important',
          letterSpacing: '-0.72px !important',
        },
      },
      '& .section-header__subtitle': {
        color: `${palette.text.tertiaryLight} !important`,
        fontWeight: 400,
        fontSize: '20px !important',
        lineHeight: '24px !important',
        letterSpacing: '-0.8px !important',
        '@media(max-width: 1200px)': {
          fontSize: '18px !important',
          lineHeight: '22px !important',
          letterSpacing: '-0.8px !important',
        },
      },
      '& .hero-button-wrapper': {
        '& .primary-static-button': {
          backgroundColor: `${palette.primary.main} !important`,
          color: `${palette.text.highlight} !important`,
          '&:hover': {
            backgroundColor: `${palette.primary.main} !important`,
            color: `${palette.text.highlight} !important`,
            opacity: 0.92,
          },
        },
        '@media(min-width: 900px)': {
          display: 'flex !important',
          justifyContent: 'right !important',
        },
        '@media(max-width: 900px)': {
          display: 'flex !important',
          justifyContent: 'center !important',
        },
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .hero-header-title': {
        fontFamily: 'InterDisplay-Medium !important',
        fontSize: '48px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.96px !important',
        fontWeight: 500,
      },
      '& .hero-header-subtitle': {
        fontFamily: 'InterDisplay-Regular !important',
        fontSize: '18px !important',
        lineHeight: '22px !important',
        letterSpacing: '-0.36px !important',
        fontWeight: 400,
      },
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .addon-bg': {
        background: palette.background.secondaryLight,
      },
      '& .MuiSwitch-thumb': {
        background: palette.primary.main,
      },
      '& .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.text.highlight,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        background: `${palette.text.highlight} !important`,
        border: `1px solid ${palette.primary.main} !important`,
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .plans-wrapper': {
        '& .planCard': {
          border: `1px solid ${palette.text.primary}`,
          '&:hover': {
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .planCardDescription': {
            height: 'calc(100% - 24px)',
          },
        },
      },
    },

    /* FAQ */
    '& .faq-hero-section': {
      '& .MuiButton-contained': {
        backgroundColor: palette.text.highlight,
        color: palette.text.primary,
      },
      '& .hero-header-title': {
        fontFamily: 'InterDisplay-Medium !important',
        fontSize: '40px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.8px !important',
        fontWeight: 500,
      },
      '& .hero-header-subtitle': {
        fontFamily: 'InterDisplay-Regular !important',
        fontSize: '18px !important',
        lineHeight: '22px !important',
        letterSpacing: '-0.4px !important',
        fontWeight: 400,
      },
      '& .hero-header-title, .hero-header-subtitle': {
        margin: '0',
        maxWidth: 'unset',
      },
      '& .header-container': {
        margin: '0',
        '& .hero-home-button': {
          background: 'transparent !important',
          color: `${palette.text.highlight} !important`,
        },
      },
      '@media screen and (max-width: 900px)': {
        '& .faq-hero-internal': {
          marginTop: '10px',
          padding: '64px 24px !important',
        },
      },
    },
    '& .faqInnerContainer': {
      '& .Mui-selected': {
        backgroundColor: palette.surface.grey,
        color: palette.text.primary,
      },
      '& .faq-link': {
        fontSize: '15px !important',
      },
      '& .accorion__item-title-container': {
        '& .MuiTypography-subtitle1': {
          fontSize: '18px !important',
          lineHeight: '22px !important',
          letterSpacing: '-0.8px !important',
          fontWeight: 500,
        },
      },
      '& .accordion__collapsable-text': {
        color: palette.text.secondary,
        fontSize: '16px !important',
        lineHeight: '20px !important',
        letterSpacing: '-0.32px !important',
        fontWeight: 400,
      },
    },
    '& .faq-contact-section': {
      background: `${palette.primary.light} !important`,
      width: '100%',
      margin: 'unset',
      maxWidth: 'unset',
      paddingInline: '80px !important',
      '@media(max-width: 1024px) and (min-width: 900px)': {
        paddingInline: '20px !important',
      },
      '@media(max-width: 900px) and (min-width: 600px)': {
        paddingInline: '40px !important',
      },
      '@media(max-width: 600px) ': {
        paddingInline: '20px !important',
      },
      '& .contact-img-wrapper': {
        width: '64px',
        maxWidth: '64px',
      },
      '& .contact-card-title': {
        fontFamily: 'InterDisplay-Medium !important',
        fontSize: '40px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.8px !important',
        fontWeight: 500,
        '@media(max-width: 600px)': {
          fontSize: '32px !important',
          lineHeight: '32px !important',
          letterSpacing: '-0.64px !important',
        },
        '@media(min-width: 600px) and (max-width: 1200px)': {
          fontSize: '36px !important',
          lineHeight: '36px !important',
          letterSpacing: '-0.72px !important',
        },
      },
      '& .contact-card-subtitle': {
        color: palette.text.secondary,
        fontSize: '20px !important',
        lineHeight: '24px !important',
        letterSpacing: '-0.48px !important',
        fontWeight: 400,
        maxWidth: 'unset',
        '@media(max-width: 600px)': {
          fontSize: '20px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.4px !important',
        },
      },
      '& .provider-contact-details': {
        fontSize: '16px !important',
        fontFamily: 'InterDisplay-Regular !important',
        lineHeight: '18px !important',
        letterSpacing: '-0.36px !important',
        fontWeight: 400,
        color: palette.text.primary,
      },
      '& .provider-contact-link': {
        color: palette.text.primary,
        fontSize: 20,
        lineHeight: '24px !important',
        letterSpacing: '-0.48px !important',
        fontFamily: 'InterDisplay-Medium !important',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        whiteSpace: 'normal',
        maxWidth: '100%',
        paddingTop: '5px',
        '@media(max-width: 600px)':{
          fontSize: '18px !important',
          lineHeight: '22px !important',
          letterSpacing: '-0.36px !important',
        }
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
      '& .termsText': {
        fontFamily: 'InterDisplay-Medium',
        fontWeight: 500,
      },
    },

    '& .success-wrapper': {
      marginTop: 120,
    },

    /* Contact Card - FAQ, Success Page */
    '& .faq-contact-wrapper': {
      background: palette.primary.light,
    },
    '& .mail-link': {
      color: palette.text.primary,
    },

    /* Dashboard Page - Appointment Header */
    '& .MuiTableRow-root .MuiTableCell-head': {
      color: palette.text.highlight,
      backgroundColor: palette.primary.main,
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      maxWidth: '598px',
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.surface.light,
      },
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.background.border ,
        color: palette.background.border,
      },
    },

    // Stepper Icon Styles - Completed vs Uncompleted
    '& .MuiStepIcon-root': {
      color: 'transparent', // Default: transparent background
      width: 32,
      height: 32,
      borderColor: palette.primary.main,

      // Completed step - filled circle with checkmark
      '&.MuiStepIcon-completed': {
        fill: `${palette.primary.main} !important`, // Filled background
        color: palette.text.highlight,
        '& .MuiSvgIcon-root': {
          color: palette.primary.main,
        },
      },

      // Active step - filled circle with number
      '&.MuiStepIcon-active': {
        fill: `${palette.primary.main} !important`, // Filled background
        color: palette.text.highlight,
        '& .MuiSvgIcon-root': {
          color: palette.primary.main,
        },
        '& .MuiStepIcon-text': {
          fill: palette.text.highlight, // White text on filled background
        },
      },

      // Uncompleted step - empty circle with number
      '&:not(.MuiStepIcon-completed):not(.MuiStepIcon-active)': {
        '& .MuiSvgIcon-root': {
          color: 'transparent',
        },
        '& .MuiStepIcon-text': {
          fill: palette.primary.main  , // Dark text on transparent background
        },
      },
    },

    // Stepper Label Styles
    '& .MuiStepLabel-label': {
      color: palette.text.primary,

      '&.MuiStepLabel-completed': {
        color: palette.text.primary,
        fontWeight: 500,
      },

      '&.MuiStepLabel-active': {
        color: palette.text.primary,
        fontWeight: 500,
      },
    },

    // Stepper Connector Line
    '& .MuiStepConnector-lineHorizontal': {
      borderColor: `${palette.background.border} !important`,
      borderTopWidth: 2,
    },

    // Stepper Container Style
    '& .stepperContainer': {
      '@media(max-width: 900px)': {
        display: 'none',
      },
    },

    '& .stepperItems': {
      marginTop: 24,
    },

    '& .footer-wrapper': {
      backgroundColor: palette.background.footer,
      paddingInline: '40px !important',
      '@media(max-width: 700px)': {
        paddingInline: '10px !important',
      },
    },
  },
};
